export default __webpack_public_path__ + "static/apple-terminal-872652f8fd2cc251ab3bd2b1a7900a36.png";